import { type FormEvent, useState } from 'react';

interface LoginScreenProps {
  readonly signingIn: boolean;
  readonly error: string | null;
  readonly onSubmit: (password: string) => void;
}

export function LoginScreen({ signingIn, error, onSubmit }: LoginScreenProps) {
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent): void => {
    event.preventDefault();
    if (password && !signingIn) onSubmit(password);
  };

  return (
    <main className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <span className="brand__mark" aria-hidden="true">
            R
          </span>
          <h1 className="login__title">Riser Mail</h1>
        </div>

        <p className="login__hint">Enter the access password to open your inboxes.</p>

        {/* role="alert" so a screen reader announces a rejected password
            instead of leaving the user with a form that silently did nothing. */}
        {error ? (
          <p className="alert" role="alert">
            {error}
          </p>
        ) : null}

        <input
          className="field"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="Password"
          aria-label="Access password"
          // The browser's password manager should offer to fill this; it is a
          // real credential even though there is no username beside it.
          autoComplete="current-password"
          autoFocus
          disabled={signingIn}
        />

        <button
          className="btn btn--primary btn--block"
          type="submit"
          disabled={signingIn || password.length === 0}
          style={{ marginTop: 12 }}
        >
          {signingIn ? 'Checking…' : 'Open mailbox'}
        </button>
      </form>
    </main>
  );
}
